// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__29eBe","info":"UpdateTermsInfo_info__3IA8J"};